module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/glarus-d0b5d5d72d8228719c4d29c445c038e7.jpg";